import * as React from 'react';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { ListWrapper } from './components/list-wrapper';
import { ListRenderer } from './components/list-renderer';
import { actionCreators } from './actions';
import { importSetAdminTranslation } from '../constants';
import { ImportSetAdminState } from '../types-store';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import { OptionsProps, withOptions } from 'app/components/options-handler';
import { AddNewImportSet } from './add-import-set/add-import-set';

export type ImportSetsAdminListProps = DefaultContainerProps
  & OptionsProps
  & ImportSetAdminState
  & typeof actionCreators;

interface ImportSetsAdminListState {
  addImportSet: boolean;
}

class ImportSetsAdminListComponent extends React.PureComponent<ImportSetsAdminListProps, ImportSetsAdminListState> {
  public static statePath: string = STATE.importSetAdministration;

  public state: ImportSetsAdminListState = {
    addImportSet: false
  };

  public componentWillUnmount() {
    this.props.clearList();
  }

  public componentDidMount() {
    scrollToTop();
  }

  private toggleAddImportSet = () => {
    this.setState({ addImportSet: !this.state.addImportSet });
  };

  public render() {

    const { list, list: { addImportSet: { validation } = {} } = {}, options, locale, sharedState, translation,
      loadList, loadOptions, deleteImportSet, displayError, updateAddImportSetFieldsByKey, resetAddImportSetValidation,
      updateAddImportSetIsDirty, updateAddImportSetState, clearAddImportSet } = this.props;

    return <ListWrapper
      displayError={displayError}
      sharedState={sharedState}
      translation={translation}>
      <ListRenderer
        listState={list}
        loadList={loadList}
        deleteImportSet={deleteImportSet}
        addImportSet={this.toggleAddImportSet}
        translation={translation}
      />
      {this.state.addImportSet && <AddNewImportSet
        onClose={this.toggleAddImportSet}
        list={list}
        loadOptions={loadOptions}
        options={options}
        updateByKey={updateAddImportSetFieldsByKey}
        resetValidation={resetAddImportSetValidation}
        translation={translation}
        updateIsDirty={updateAddImportSetIsDirty}
        updateState={updateAddImportSetState}
        clearAddImportSet={clearAddImportSet}
        validation={validation}
        locale={locale}
      />}
    </ListWrapper>;
  }
}

const container = containerFactory(withOptions(ImportSetsAdminListComponent), actionCreators, undefined, importSetAdminTranslation);

export { container as ImportSetsAdminList };
